module.exports = __webpack_public_path__ + "img/leaflet-logo.2762c8f4.png";